import { Component } from '@verndale/core';
import { nanoid } from 'nanoid';

import { isIE } from '../utils/browsers';

class FullWidthMedia extends Component {
  setupDefaults() {
    this.dom = {
      $image: this.el._$('img.full-width-media__media'),
      $overlay: this.el._$('.full-width-media__overlay'),
      $wrapper: this.el._$('.full-width-media__wrapper')
    };

    this.playButtonLabel = this.el.dataset.playButtonLabel;
    this.videoTitle = this.el.dataset.videoTitle;
    this.videoId = this.el.dataset.videoId;
    this.containerId = `video-${nanoid()}`;
    this.addVideoPlayer();
  }

  addListeners() {
    const { $overlay } = this.dom;

    $overlay._on('click', ::this.handleClick);
  }

  handleClick(e) {
    const $button = e.target.closest('.full-width-media__play-button');

    if ($button) {
      this.removeOverlay($button);
      this.removeImage();
      this.el.dataset.hideGradient = 'true';
    }
  }

  removeOverlay($button) {
    if ($button) {
      const { $overlay, youtubeVideo, $wrapper } = this.dom;
      const $iframe = $wrapper._$('iframe');
      $iframe.removeAttribute('tabindex');

      if (isIE) {
        $iframe.src = `${$iframe.src}?autoplay=1&rel=0`;
      } else {
        youtubeVideo?.play();
      }

      $iframe.focus();
      $overlay.parentNode.removeChild($overlay);
    }
  }

  removeImage() {
    const { $image } = this.dom;

    if ($image) {
      $image.parentNode.removeChild($image);
    }
  }

  addVideoPlayer() {
    const { $wrapper, $overlay } = this.dom;

    $wrapper.insertAdjacentHTML('afterbegin', this.getIframe());

    if (isIE) {
      return $overlay.insertAdjacentHTML('afterbegin', this.getPlayButton());
    }
    const createVideoPlayer = () => {
      import('yt-player').then((module) => {
        const YTPlayer = module.default;
        const element = this.el._$(`.${this.containerId}`);

        this.dom.youtubeVideo = new YTPlayer(element, {
          related: false,
          modestBranding: true,
          host: '//youtube.com'
        });
        this.dom.youtubeVideo.load(this.videoId);
        $overlay.insertAdjacentHTML('afterbegin', this.getPlayButton());
      });
    };

    if (window.YT) return createVideoPlayer();
    window.onYouTubeIframeAPIReady = createVideoPlayer;
  }

  getIframe() {
    return isIE
      ? `
      <div class="full-width-media__media">
        <iframe
          loading="lazy"
          src="https://www.youtube.com/embed/${this.videoId}"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen="allowfullscreen"
          msallowfullscreen="msallowfullscreen"
          webkitallowfullscreen="webkitallowfullscreen"
          title="${this.videoTitle}"
          tabindex="-1"
        ></iframe>
      </div>
    `
      : `
      <div class="full-width-media__media">
        <div class="${this.containerId}" tabindex="-1"></div>
      </div>
    `;
  }

  getPlayButton() {
    return `
      <button class="full-width-media__play-button" aria-label="${this.playButtonLabel}">
        <svg aria-hidden="true">
          <use xlink:href="#play-outline" />
        </svg>
      </button>
    `;
  }
}

export default FullWidthMedia;
